import servicioBase from '@/services/servicio-base'

const servicioCatalogo = {}

servicioCatalogo.clasificaciones =  () => {
    return servicioBase.get('/catalogos/clasificaciones')
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioCatalogo.catclasificaciones =  () => {
    return servicioBase.get('/catalogos/general/clasificaciones')
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioCatalogo.catcategorias =  (clasificacion) => {
    return servicioBase.get('/catalogos/general/categorias/'+ clasificacion)
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioCatalogo.catlineas =  (clasificacion, categorias) => {
    return servicioBase.get('/catalogos/general/lineas/'+ clasificacion + '/' + categorias )
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioCatalogo.catarticulos =  (clasificacion, categoria, linea, pagina) => {
    return servicioBase.get('/catalogos/general/articulos/'+ clasificacion + '/' + categoria + '/' + linea + '/' + pagina )
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioCatalogo.formasFarmaceuticas =  params => {
    return servicioBase.post('/catalogos/FormasFarmaceuticas', params)
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}



export default servicioCatalogo